import React, { Component } from 'react';

import ParkinglocationSelect from './ParkinglocationSelect';

import { Form, Input, InputNumber, Button, Modal, Select, Divider, Switch, Icon } from 'antd';
import { withState } from 'recompose';
const FormItem = Form.Item;

class ParkinglocationSettingsForm extends Component {

  state = {
    modalVisible: false
  }

  form = null;

  componentWillReceiveProps(nextProps) {
    this.setState({
      modalVisible: nextProps.modalVisible
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.onSuccess(this.props.form, values);
      }
    });
  }

  renderForm() {
    const { getFieldDecorator } = this.props.form;

    // if (this.props.initValues !== undefined && this.props.initValues !== null) {
    //   this.props.form.setFields(this.props.initValues);
    // }

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
      },
    };

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <Form onSubmit={this.handleSubmit} ref={ref => { this.form = ref }}>
        <FormItem
          {...formItemLayout}
          label="Název" >
          {getFieldDecorator('Name', {
            initialValue: this.props.initialValues && this.props.initialValues.Name
              ? this.props.initialValues.Name
              : null,
            rules: [{
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <Input />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Kapacita" >
          {getFieldDecorator('Capacity', {
            initialValue: this.props.initialValues && this.props.initialValues.Capacity
              ? this.props.initialValues.Capacity
              : null,
            rules: [{
              type: 'integer', message: 'Položka musí obsahovat číslo!',
            }, {
              required: true, message: 'Zadejte prosím tuto položku!',
            }],
          })(
            <InputNumber
              min={0}
              max={99999} />
          )}
        </FormItem>
        <FormItem {...tailFormItemLayout}>
          <Button type="primary" htmlType="submit">Uložit</Button>
        </FormItem>
      </Form>
    );
  }

  render() {
    if (this.props.type && this.props.type === 'modal') {
      return (
        <Modal
          width={700}
          title="Nastavení lokality"
          visible={this.state.modalVisible}
          onCancel={() => {
            this.props.onModalCancel(this.props.form);
            this.setState({ modalVisible: false });
          }}
        >
          {this.renderForm()}
        </Modal>
      )
    } else {
      return this.renderForm();
    }
  }
}

const WrappedParkinglocationForm = Form.create()(ParkinglocationSettingsForm);

export default WrappedParkinglocationForm;


// WEBPACK FOOTER //
// ./src/components/ParkinglocationSettingsForm.js